// @flow
import * as React from 'react';
import styled from 'styled-components';
import ModalBase, { Dialog, CloseButton } from 'modals/ModalBase';
import Box from 'components/Box';
import { H2 } from 'components/Heading';
import { breakpoints, colors } from '../theme';

const StyledDialog = styled(Dialog)`
  background-image: linear-gradient(to left, #1d91e9, ${colors.niceBlue});
  background-size: 100% 7px;
  background-repeat: no-repeat;
  padding-top: 42px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 35px;
  ${props =>
    props.fullWidth &&
    `
    max-width: none;
  `}
  @media (min-width: ${breakpoints[2]}) {
    padding-top: 40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
    ${props => props.wide && `min-width: 650px`}
  }
`;

const StyledCloseButton = styled(CloseButton)`
  color: ${colors.battleshipGrey};
  &:hover {
    color: ${colors.waterBlue};
    &:disabled {
      &:hover {
        color: ${colors.battleshipGrey};
      }
    }
  }
`;

type Props = {
  children: React.Node,
  className?: string,
  noCloseButton?: boolean,
  overlayComponent?: React.ComponentType<any>,
  title?: React.Node,
  onClose?: Function,
  'data-qa-id'?: string,
  wide?: boolean,
  fullWidth?: boolean
};

export default class Modal extends React.PureComponent<Props> {
  get title() {
    return this.props.title ? (
      <H2 styleAs="h3" pb={2}>
        {this.props.title}
      </H2>
    ) : null;
  }

  render() {
    return (
      <ModalBase
        className={this.props.className}
        onClose={this.props.onClose}
        overlayComponent={this.props.overlayComponent}
        renderDialog={onDialogClick => (
          <StyledDialog
            onClick={onDialogClick}
            data-qa-id={this.props['data-qa-id']}
            wide={this.props.wide}
            fullWidth={this.props.fullWidth}
          >
            {this.props.onClose && !this.props.noCloseButton && (
              <StyledCloseButton
                onClick={this.props.onClose}
                data-qa-id="close-modal-button"
                data-modal-focus="false"
              />
            )}
            <Box>
              {this.title}
              {this.props.children}
            </Box>
          </StyledDialog>
        )}
      />
    );
  }
}
